import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fivezeroseaterbusonrentforschool() {



const cardData =
{
  keyword: '50 Seater Bus on Rent for School Trip Pune',
  heading: 'Sanavi Travels: 50 Seater Bus on Rent for School Trip Pune',
  headingDescription: 'Sanavi Travels provides safe, reliable, and well-managed 50 Seater Bus on Rent for School Trip Pune services, specially designed for schools, colleges, educational institutes, and parent groups planning local or outstation school trips. Our 50-seater buses are ideal for transporting large groups of students together in a disciplined, comfortable, and secure manner, ensuring smooth coordination, punctual schedules, and a stress-free travel experience for teachers, parents, and students.',

  top: 'Popular School Trip & Educational Tour Destinations from Pune',

  "topPlaces": [
    {
      "title": "Educational Day Trips Around Pune",
      "description": "Educational day trips around Pune include science parks, museums, historical monuments, and nature centers that support experiential learning for students. Hiring a 50 seater bus allows entire classes to travel together under teacher supervision, ensuring discipline, safety, and time management. Spacious seating, wide aisles, and comfortable interiors help students remain calm and organized throughout the journey. Teachers can easily monitor students, distribute instructions, and manage attendance, making educational trips productive and well-coordinated from start to finish."
    },
    {
      "title": "School Picnic Spots Near Pune",
      "description": "School picnic spots near Pune such as gardens, resorts, water parks, and recreational zones are popular choices for annual school outings. A 50 seater bus is ideal for transporting students, staff, and accompanying parents together in one vehicle, reducing logistical complexity. Students enjoy traveling with classmates, while schools benefit from simplified planning, single-point coordination, and controlled group movement. Comfortable seating and smooth driving ensure students arrive fresh and ready to enjoy activities."
    },
    {
      "title": "Historical & Cultural Tours",
      "description": "Historical and cultural tours are an important part of school education, helping students connect with heritage, history, and traditions. A 50 seater bus supports large student groups visiting forts, monuments, temples, and cultural centers. With professional drivers familiar with school routes and tourist destinations, travel remains safe and punctual. Students can focus on learning experiences rather than travel fatigue."
    },
    {
      "title": "Outstation School Trips",
      "description": "Outstation school trips require reliable, safe, and well-maintained buses that can handle longer travel distances. 50 seater buses are ideal for overnight or multi-day school tours, offering sufficient space for students, teachers, and luggage. Comfortable seating, smooth suspension, and disciplined travel arrangements help ensure students remain comfortable and safe throughout the journey."
    },
    {
      "title": "Science Parks & Learning Centers",
      "description": "Visits to science parks, planetariums, and learning centers enhance student curiosity and engagement. A 50 seater school trip bus allows entire classes to travel together, maintaining schedule integrity and reducing delays. Teachers can prepare students during travel, making the journey itself an extension of learning."
    },
    {
      "title": "Nature & Environmental Study Trips",
      "description": "Nature trails, eco parks, and environmental study centers are commonly included in school curricula. Traveling in a 50 seater bus ensures students remain together under supervision while enjoying scenic routes. The spacious layout helps manage water bottles, study materials, and safety equipment comfortably."
    },
    {
      "title": "Inter-School Competitions & Events",
      "description": "Schools often travel for competitions, sports meets, and cultural events. A 50 seater bus provides reliable group transport, ensuring teams arrive together, on time, and well-prepared. Coordinated travel improves discipline and reduces stress for event organizers and teachers."
    },
    {
      "title": "School Annual Excursions",
      "description": "Annual school excursions are major events requiring careful planning. 50 seater buses simplify transportation by accommodating large student groups in a single vehicle, ensuring smooth roll-calls, easy supervision, and consistent schedules throughout the trip."
    },
    {
      "title": "Student Picnic & Fun Trips",
      "description": "Fun-oriented student picnics focus on relaxation, bonding, and enjoyment. Comfortable bus travel helps students stay energetic and positive, allowing them to enjoy games and activities upon arrival without travel exhaustion."
    },
    {
      "title": "Customized School Routes & Timings",
      "description": "Every school trip has unique requirements. 50 seater bus rentals allow route customization, flexible pickup points, and adjustable schedules, ensuring the trip aligns perfectly with school planning and student needs."
    }
  ],

  "services": [
    {
      "name": "50 Seater Bus on Rent for School Trip Pune",
      "description": "Sanavi Travels offers dedicated 50 seater buses for school trips in Pune, focusing on safety, comfort, and disciplined group travel. These buses are ideal for transporting large student groups along with teachers and staff, ensuring everyone travels together in a controlled environment. Spacious seating, reliable performance, and professional drivers help schools manage trips efficiently. Transparent pricing, flexible scheduling, and school-friendly service standards make this option a trusted choice for educational institutions."
    },
    {
      "name": "AC 50 Seater Bus for School Trip Pune",
      "description": "AC 50 seater buses provide a comfortable travel environment for students, especially during warm weather or long journeys. Air-conditioned interiors help students stay relaxed, attentive, and energetic throughout the trip."
    },
    {
      "name": "Non AC 50 Seater Bus for School Trip Pune",
      "description": "Non-AC 50 seater buses offer a budget-friendly option for short-distance school trips while maintaining safety, seating capacity, and reliability for student travel."
    },
    {
      "name": "Luxury 50 Seater Bus Hire for School Trip Pune",
      "description": "Luxury 50 seater buses are suitable for premium school excursions, inter-city tours, or special events, offering enhanced comfort, better interiors, and smooth travel experiences."
    },
    {
      "name": "50 Seater Bus for Students Pune",
      "description": "Student-focused 50 seater buses are designed to handle group travel efficiently, allowing teachers to supervise easily and students to travel together comfortably."
    },
    {
      "name": "50 Seater Bus for Group School Trip Pune",
      "description": "Group school trips benefit from single-vehicle travel, reducing coordination challenges and ensuring punctual arrivals at destinations."
    },
    {
      "name": "Affordable 50 Seater Bus Rental for School Trip Pune",
      "description": "Affordable rental plans help schools manage budgets without compromising on safety or reliability. Transparent pricing supports easy planning and approvals."
    },
    {
      "name": "Best 50 Seater Bus Service for School Trip Pune",
      "description": "Sanavi Travels is recognized for dependable school trip bus services, offering consistent quality, punctual service, and professional coordination."
    },
    {
      "name": "50 Seater Bus with Driver for School Trip Pune",
      "description": "All buses include trained drivers experienced in handling school travel routes, student safety protocols, and disciplined driving practices."
    },
    {
      "name": "Outstation 50 Seater Bus for School Trip Pune",
      "description": "Outstation school trips require sturdy, comfortable buses capable of long journeys. 50 seater buses provide adequate space and comfort for multi-day tours."
    }
  ],

  "tableData": [
    ["50 Seater Bus", "School Trip"],
    ["AC Bus", "Non AC Bus"],
    ["Local Trips", "Outstation Trips"],
    ["Student Travel", "Group Travel"],
    ["Affordable", "Luxury Options"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Student Safety Priority", "WhyChoosedescription": "Safe and supervised travel for students." },
    { "WhyChooseheading": "Large Group Capacity", "WhyChoosedescription": "Ideal for entire classes and staff." },
    { "WhyChooseheading": "Experienced Drivers", "WhyChoosedescription": "Drivers trained for school transport." },
    { "WhyChooseheading": "Clean & Maintained Buses", "WhyChoosedescription": "Hygienic and well-serviced vehicles." },
    { "WhyChooseheading": "Budget-Friendly Plans", "WhyChoosedescription": "Affordable pricing for schools." },
    { "WhyChooseheading": "On-Time Scheduling", "WhyChoosedescription": "Punctual pickups and drops." },
    { "WhyChooseheading": "Flexible Routes", "WhyChoosedescription": "Customized school trip planning." },
    { "WhyChooseheading": "Trusted School Partner", "WhyChoosedescription": "Preferred by schools across Pune." }
  ]
};

const faqData = [
  { question: 'Do you provide 50 seater buses for school trips in Pune?', answer: 'Yes, Sanavi Travels offers 50 seater buses for school trips in Pune.' },
  { question: 'Are AC and Non AC options available?', answer: 'Yes, both AC and Non AC buses are available.' },
  { question: 'Are drivers experienced with school travel?', answer: 'Yes, drivers are trained and experienced in school transportation.' },
  { question: 'Is the service suitable for outstation school trips?', answer: 'Yes, outstation school trips are fully supported.' },
  { question: 'Can schools customize pickup points?', answer: 'Yes, routes and pickups can be customized.' },
  { question: 'Is pricing affordable for schools?', answer: 'Yes, we offer school-friendly pricing.' },
  { question: 'Are buses maintained regularly?', answer: 'Yes, buses are cleaned and serviced regularly.' },
  { question: 'Is advance booking required?', answer: 'Advance booking is recommended for availability.' },
  { question: 'Can teachers travel along with students?', answer: 'Yes, teachers and staff can travel together.' },
  { question: 'Do you handle large student groups?', answer: 'Yes, 50 seater buses are ideal for large groups.' }
];

const testimonials = [
  {
    id: 1,
    name: 'School Administrator, Pune',
    feedback: 'Very safe and organized transport for our school trip. Highly satisfied.',
    rating: 5
  },
  {
    id: 2,
    name: 'Teacher, Pune',
    feedback: 'Comfortable bus and disciplined travel for students. Excellent service.',
    rating: 5
  }
];





























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "50 Seater Bus on Rent for School Trip Pune",
  "serviceType": "School Trip Bus Rental",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Sanavi Travels",
    "telephone": "+91 7387507373"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "description":
    "Book 50 seater buses on rent in Pune for school trips, educational tours, picnics, excursions and group travel with professional drivers.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.7,
    "bestRating": 5,
    "worstRating": 1,
    "ratingCount": 10000
  }
};




  return (
    <div>

<Helmet>
  <title>
    50 Seater Bus on Rent Pune for School Trips | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire a 50 seater bus on rent in Pune for school trips, educational tours, picnics, excursions and student travel. AC & Non-AC buses with experienced drivers."
  />

  <meta
    name="keywords"
    content="50 seater bus on rent Pune, school trip bus Pune, bus rental Pune for school, educational tour bus Pune, school excursion bus Pune, bus hire Pune"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/50-seater-bus-on-rent-school-trip-pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/295.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fivezeroseaterbusonrentforschool;